import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiRemove, apiSearch } from '../../modules/utility';
const apiBase = 'rebateCampaign';
const urlPrefix = 'rebateCampaign';
const plural = 'rebateCampaigns';
const word = 'rebate campaigns';

const mapStateToProps = (state, ownProps) => {
	let rebateCampaigns = [];
	let rebateCampaign;
	let rebateCampaignId;

	if (state.lists.rebateCampaignIds) {
		rebateCampaigns = _.map(state.lists.rebateCampaignIds, (id) => state.maps.rebateCampaign[id]);
	}

	if (ownProps.rebateCampaign) {
		rebateCampaign = ownProps.rebateCampaign;
	} else {
		rebateCampaignId = ownProps.rebateCampaignId
			? ownProps.rebateCampaignId
			: _.get(ownProps, ['match', 'params', 'rebateCampaignId']);
		rebateCampaign = _.get(state.maps, ['rebateCampaign', rebateCampaignId]);
	}
	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	return {
		canMakeUpdates,
		rebateCampaign,
		rebateCampaigns,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		stationMap: state.maps.station,
	};
};

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {},
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate: 'bulkCustomerIds',
			params,
			dispatch,
			successMessage: `The ${word} was created successfully. 
				Click continue to return to the ${word} page.`,
			onSuccessRedirectTo: `/${urlPrefix}/${plural}`,
			callback,
		});
	};
};

const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage: `The ${word} updated successfully. 
				Click continue to return to the ${word} page.)`,
			onSuccessRedirectTo: `/${urlPrefix}/${plural}`,
			callback,
		});
	};
};

const remove = ({ bulkCustomerId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: bulkCustomerId,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			rebateCampaignGet: get,
			rebateCampaignSearch: search,
			rebateCampaignAdd: add,
			rebateCampaignUpdate: update,
			rebateCampaignRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
